"use client"

import type { ReactNode } from "react"

import Style from "./ResponsiveOnly.module.scss"

interface ResponsiveOnlyProps {
	children: ReactNode
}

/**
 * 仅在 PC 端显示（> 768px）。纯 CSS 显隐，服务端与客户端 DOM 一致，PC 首屏不延迟。
 */
export function DesktopOnly({ children }: ResponsiveOnlyProps) {
	return <div className={Style.desktopOnly}>{children}</div>
}

/**
 * 仅在移动端显示（<= 768px）。纯 CSS 显隐，服务端与客户端 DOM 一致，无 hydration 问题。
 */
export function MobileOnly({ children }: ResponsiveOnlyProps) {
	return <div className={Style.mobileOnly}>{children}</div>
}

// ---------- 以下为 useResponsive 实现 ----------
// import { useResponsive } from "ahooks"
// import { useEffect, useState } from "react"
//
// function useIsMobile() {
//   const responsive = useResponsive()
//   if (!responsive || typeof responsive.md === "undefined") return null
//   return !responsive.md
// }
//
// export function DesktopOnlyJs({ children }: ResponsiveOnlyProps) {
//   const [mounted, setMounted] = useState(false)
//   const isMobile = useIsMobile()
//   useEffect(() => setMounted(true), [])
//   if (!mounted) return null
//   if (isMobile) return null
//   return <>{children}</>
// }
//
// export function MobileOnlyJs({ children }: ResponsiveOnlyProps) {
//   const [mounted, setMounted] = useState(false)
//   const isMobile = useIsMobile()
//   useEffect(() => setMounted(true), [])
//   if (!mounted) return null
//   if (!isMobile) return null
//   return <>{children}</>
// }
